import React from 'react';
import { FaYoutube, FaInstagram } from 'react-icons/fa6';
import { SiBuymeacoffee } from 'react-icons/si';
import { BUY_ME_A_COFFEE_URL } from '../data/links';
import textLogo from '../assets/surthrivaling_text_logo.png';

const YOUTUBE_URL = 'https://www.youtube.com/@surthrivaling';
const INSTAGRAM_URL = 'https://www.instagram.com/surthrivaling';

const META_STRIP = ['Money', 'Relationships', 'Travel', 'Work'];

function Hero() {
  return (
    <section id="hero" className="hero">
      <div className="hero__glow" aria-hidden="true" />
      <div className="container hero__container">
        <aside className="hero__meta" aria-label="Topics">
          <ul className="hero__meta-list">
            {META_STRIP.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </aside>

        <div className="hero__content reveal">
          <img
            src={textLogo}
            alt="Surthrivaling"
            className="hero__logo"
          />

          <p className="hero__tagline">
            Two Parts Surviving. One Part Thriving. Thoroughly shaken...occasionally stirred.
          </p>

          <p className="hero__sub">
            Observations on work, travel, the search for freedom (whatever that is), and all the living in between. It&rsquo;ll definitely be messy, but it certainly won&rsquo;t be boring.
          </p>

          <div className="hero__actions">
            <a
              href={YOUTUBE_URL}
              className="btn btn--accent hero__btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaYoutube aria-hidden="true" />
              YouTube
            </a>
            <a
              href={INSTAGRAM_URL}
              className="btn btn--outline hero__btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram aria-hidden="true" />
              Instagram
            </a>
            <a
              href={BUY_ME_A_COFFEE_URL}
              className="btn btn--outline hero__btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SiBuymeacoffee aria-hidden="true" />
              Buy Me A Coffee
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
